import React, { useEffect } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';

import { scrollTo } from "~/utils/helpers";

import Link from '~/components/ui/Link';
import { Advantages } from '~/containers/expertise/advantages';
import { CollapsedItem } from '~/containers/expertise/collapsedItem';
import { advantagesContent } from '~/containers/expertise/advantagesContent';
import { Steps } from '~/containers/expertise/steps';
import { SliderExpertise } from '~/containers/expertise/sliderExpertise';
import styles from '~/containers/expertise/styles';

interface IExpertiseProps {
    location: any
}

const link1 = `${process.env.GATSBY_IMAGES}linksImage/link1.png`;
const link2 = `${process.env.GATSBY_IMAGES}linksImage/link2.png`;
const link3 = `${process.env.GATSBY_IMAGES}linksImage/link3.png`;
const link4 = `${process.env.GATSBY_IMAGES}linksImage/link4.png`;
const link1WebP = `${process.env.GATSBY_IMAGES}linksImage/link1.webp`;
const link2WebP = `${process.env.GATSBY_IMAGES}linksImage/link2.webp`;
const link3WebP = `${process.env.GATSBY_IMAGES}linksImage/link3.webp`;
const link4WebP = `${process.env.GATSBY_IMAGES}linksImage/link4.webp`;

export const Expertise = (props: IExpertiseProps) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
    const isTablet = useMediaQuery(theme.breakpoints.down('md'))
    const classes = styles()

    useEffect(() => {
        let hash = location.hash.replace('#', '');
        scrollTo(hash, 150);
    });

    return (
        <>
            <div className={classes.heroContainer}>
                <div className={classes.heroImage}></div>
            </div>
            <div className={classes.mainContainer}>
                <div
                    className={clsx(
                        classes.flexColumnBlock,
                        classes.perfectlyAlignedBlock
                    )}
                >
                    <Typography
                        className={classes.perfectSubTitle}
                        variant="overline"
                    >
                        ORTHOSNAP CLEAR ALIGNER
                    </Typography>
                    <Typography
                        className={classes.perfectTitle}
                        variant={isMobile ? 'h4' : 'h3'}
                    >
                        Perfectly Aligned to Grow Your Practice
                    </Typography>
                    <Typography className={classes.perfectText} variant="body1">
                        Treatment for orthodontic malocclusion is an $11 billion
                        dollar global industry, and it’s only continuing to grow
                        with DIY aligner sales skyrocketing by 21% last year.
                        But DIY treatments often lead to mixed results,
                        non-compliance and dissatisfaction.
                    </Typography>
                </div>
                <div
                    className={clsx(
                        classes.flexRowBlock,
                        classes.betterOutcomeContainer
                    )}
                >
                    <div
                        className={clsx(
                            classes.flexColumnBlock,
                            classes.betterOutcomeContainerItems
                        )}
                    >
                        <Typography
                            variant="subtitle1"
                            className={classes.betterOutcomeHeader}
                        >
                            Better Outcomes = Better Revenue
                        </Typography>
                        <Typography
                            variant="body1"
                            className={classes.betterOutcomeText}
                        >
                            Orthosnap is upending the market by giving dentists
                            a solution that delivers better, faster results at
                            the price-point of direct-to-consumer competitors.
                        </Typography>
                        <Typography
                            variant="body1"
                            className={classes.betterOutcomeText}
                        >
                            Orthosnap also helps dental practitioners expand the
                            range of services they offer, increase patient
                            loyalty, and drive overall productivity with a
                            substantial new revenue stream. Orthosnap provides
                            the full scope of service for what’s needed.
                        </Typography>
                    </div>
                    <div className={classes.betterOutcomeContainerItems}>
                        <div className={classes.betterOutcomeImage}></div>
                    </div>
                </div>
                <Advantages />
                <div className={classes.advantagesBlock}>
                    {advantagesContent.map(({ key, title, content, image }) => (
                        <CollapsedItem
                            key={key}
                            imagePath={image}
                            title={title}
                            content={content}
                        />
                    ))}
                </div>
            </div>
            <SliderExpertise />
            <Steps />
            <Grid
                id="getting-started"
                container
                spacing={isTablet ? 3 : 4}
                className={classes.linksBlock}
            >
                <Grid item xs={12}>
                    <Typography
                        variant="subtitle2"
                        className={classes.linksTitle}
                    >
                        Getting Started
                    </Typography>
                    <Typography
                        variant="body1"
                        className={classes.linksSubTitle}
                    >
                        Check out our tips for a successful treatment plan.
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Link
                        imagePath={link1}
                        imagePathWebP={link1WebP}
                        linkText="Selecting a New Case"
                        href="//help.orthosnap.com/en/collections/2287587-selecting-cases-for-treatment"
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Link
                        imagePath={link2}
                        imagePathWebP={link2WebP}
                        linkText="Tips on Taking Impressions"
                        href="//help.orthosnap.com/en/articles/3552877-tips-on-taking-impressions"
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Link
                        imagePath={link3}
                        imagePathWebP={link3WebP}
                        linkText="What to Expect"
                        href="//help.orthosnap.com/en/collections/2287584-clear-aligner-orthodontics-basics"
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Link
                        imagePath={link4}
                        imagePathWebP={link4WebP}
                        linkText="The Origin Model"
                        href="//help.orthosnap.com/en/articles/4154743-how-the-origin-model-and-origin-aligner-work-together"
                    />
                </Grid>
            </Grid>
        </>
    )
}
